module.exports = __webpack_public_path__ + "assets/0fdda991a56922059fe815c03180e4d5.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-16.woff
// module id = 3631
// module chunks = 0